import FilterBar from '../../components/FilterBar/FilterBar';
import VideoCard from '../../components/VideoCard';
import VideoCardSide from '../../components/VideoCardSide';
import Pagination from '../../components/Pagination';
import { useMyVideoList } from './useMyVideoList';
import LoadingIndicator from '../../components/LoadingIndicator';
import styles from './MyVideoList.module.css';

/**
 * 自分の投稿動画一覧を表示するコンポーネント
 * 公開中動画と非公開動画をフィルターとソートで管理
 */
const MyVideoList = () => {
  const {
    isMobile,
    videos,
    pagination,
    currentPage,
    sortOrder,
    specialty,
    specialtyOptions,
    isLoading,
    handleSortOrderChange,
    handlePageChange,
    handleVisibilityChange,
    handleSpecialtyChange,
  } = useMyVideoList();

  return (
    <div className={styles['my-video-list__container']} data-testid="my-video-list">
      <FilterBar
        sortOrder={sortOrder}
        onSortOrderChange={handleSortOrderChange}
        specialty={specialty}
        onSpecialtyChange={handleSpecialtyChange}
        procedure=""
        onProcedureChange={() => {}}
        specialtyOptions={specialtyOptions}
      />

      <div className={styles['my-video-list__content']}>
        <div className={styles['my-video-list__section-container']}>
          <div className={styles['my-video-list__section-card']}>
            <div className={styles['my-video-list__video-grid-container']}>
              {isLoading ? (
                <div className={`${styles['my-video-list__loading-container']} ${styles['my-video-list__grid-full-width']}`} data-testid="my-video-list__loading">
                  <LoadingIndicator className={styles['my-video-list__loading-indicator']} />
                </div>
              ) : videos.length > 0 ? (
                <div className={styles['my-video-list__video-grid']} data-testid="my-video-list__grid">
                  {videos.map((video) => (
                    <div className={styles['my-video-list__video-card-wrapper']} key={video.id} data-testid={`my-video-list__video-${video.id}`}>
                      {isMobile ? (
                        <VideoCardSide
                          video={video}
                          onVisibilityChange={handleVisibilityChange}
                          hideVisibilityToggle={false}
                          showEditButton={true}
                        />
                      ) : (
                        <VideoCard
                          video={video}
                          onVisibilityChange={handleVisibilityChange}
                          hideVisibilityToggle={false}
                          showEditButton={true}
                        />
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <div className={styles['my-video-list__empty-container']} data-testid="my-video-list__empty">
                  <p className={styles['my-video-list__empty-message']}>
                    {specialty ? '選択した診療科の動画がありません。' : '動画がありません。'}
                  </p>
                </div>
              )}
            </div>

            {!isLoading && videos.length > 0 && pagination.totalPages > 1 && (
              <div className={styles['my-video-list__pagination-container']}>
                <Pagination
                  currentPage={currentPage}
                  totalPages={pagination.totalPages}
                  onPageChange={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyVideoList;
